import { ProductAlert } from '../../../types';
import { Omit } from 'react-router';
import * as React from 'react';

type InputProps = JSX.IntrinsicElements['input'];
/* For correctness, restrict the name of the input field to a key of the ProductAlert class,
 * since the name will be used to assign values to the object. */
type AlertInputProps = Omit<InputProps, 'name'> & { name: keyof ProductAlert };
export default function AlertInput(props: AlertInputProps): JSX.Element {
    return (
        <input {...props} />
    );
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/Alerts/form/AlertInput.tsx